import Microgame from '../engine/Microgame.js';

export default class JumpGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Saute !`, en: `Jump!`, es: `¡Salta!` },
            controls: { fr: `Appuie sur l'écran pour sauter`, en: `Tap the screen to jump`, es: `Toca la pantalla para saltar` },
            objective: { fr: `Saute par-dessus l'obstacle au bon moment`, en: `Jump over the obstacle at the right time`, es: `Salta el obstáculo en el momento adecuado` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M16 18h6"/><path d="M2 18h6"/><path d="M12 19v-4"/><path d="M12 11V7"/><circle cx="12" cy="4" r="2"/></svg>`,
            actions: [
                { type: 'wait', duration: 1400 },
                { type: 'tap', x: 30, y: 75, duration: 140 },
                { type: 'wait', duration: 500 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.player = null;
        this.obstacle = null;
        this.isJumping = false;
        this.velocityY = 0;
        this.gravity = 2500;
        this.jumpForce = -600;
        this.groundY = 0;
        this.playerY = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "JUMP!";

        // Ground line
        const ground = document.createElement('div');
        ground.style.position = 'absolute';
        ground.style.bottom = '100px';
        ground.style.width = '100%';
        ground.style.height = '2px';
        ground.style.background = this.secondaryColor;
        this.container.appendChild(ground);

        this.groundY = 100;
        this.playerY = this.groundY;

        // Player
        this.player = document.createElement('div');
        this.player.style.position = 'absolute';
        this.player.style.width = '40px';
        this.player.style.height = '40px';
        this.player.style.background = this.primaryColor;
        this.player.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.player.style.bottom = `${this.playerY}px`;
        this.player.style.left = '20%';
        this.container.appendChild(this.player);

        // Obstacle (Laser)
        this.obstacle = document.createElement('div');
        this.obstacle.style.position = 'absolute';
        this.obstacle.style.width = '20px';
        this.obstacle.style.height = '40px';
        this.obstacle.style.background = this.secondaryColor;
        this.obstacle.style.boxShadow = `0 0 15px ${this.secondaryColor}`;
        this.obstacle.style.bottom = `${this.groundY}px`;
        // Start off-screen to the right with a random delay (distance)
        // Keep it feasible even at speed 4.0: max distance = 300px
        const randomDistance = this.isPlayback ? 120 : Math.random() * 300;
        this.obstacle.style.left = `${this.container.clientWidth + randomDistance}px`;
        this.container.appendChild(this.obstacle);

        this.onDown = this.onDown.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
    }

    onDown() {
        if (!this.active || this.isJumping) return;
        this.isJumping = true;
        this.velocityY = this.jumpForce;
    }

    update(dt) {
        if (!this.active) return;

        // Move Obstacle
        const speedMult = this.engine.speedMultiplier || 1.0;
        const speed = 300 * speedMult; // px/s, slower base but scales with engine speed
        let obsLeft = parseFloat(this.obstacle.style.left) || this.container.clientWidth;
        obsLeft -= speed * (dt / 1000);
        this.obstacle.style.left = `${obsLeft}px`;

        // Reset obstacle if off screen (loop for difficulty or just one pass?)
        // Let's make it one pass for "Quicky" feel, or loop until time.
        // Actually, usually these are "survive" or "do it once".
        // Let's say survive for the duration.
        if (obsLeft < -50) {
            obsLeft = this.container.clientWidth + Math.random() * 200;
            this.obstacle.style.left = `${obsLeft}px`;
            // Win if we survive long enough? Or win immediately after one jump?
            // WarioWare usually is "Jump!" -> Jump over one thing -> Win.
            // Let's make it: if it passes player successfully, win.
            // But we need to wait until it's off screen.
            if (!this.won) {
                this.win();
            }
        }

        // Player Physics
        if (this.isJumping) {
            this.velocityY += this.gravity * (dt / 1000);
            this.playerY -= this.velocityY * (dt / 1000);

            if (this.playerY <= this.groundY) {
                this.playerY = this.groundY;
                this.isJumping = false;
                this.velocityY = 0;
            }
            this.player.style.bottom = `${this.playerY}px`;
        }

        // Collision
        const pRect = this.player.getBoundingClientRect();
        const oRect = this.obstacle.getBoundingClientRect();

        // Simple AABB with some forgiveness
        const padding = 10;
        if (
            pRect.right - padding > oRect.left &&
            pRect.left + padding < oRect.right &&
            pRect.bottom - padding > oRect.top &&
            pRect.top + padding < oRect.bottom
        ) {
            this.lose();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
    }
}
